<template>
  <div>
    <div>
      <Mastermap :imgSrc='masterMap.imgSrc' :companyName='masterMap.companyName' :masterTitle='masterMap.masterTitle'>
      </Mastermap>
    </div>
    <div class="container">
      <div class="area">
        <div class="top">
          <div class='item' v-for="(item,i) in contactWays" :key="i">
            <img :src="item.imgSrc" alt="icon">
            <h2>{{item.title}}</h2>
            <p :class="item.title ? '' : 'shifen'">{{item.subTitle}}</p>
          </div>
        </div>
        <img class="map" src="../assets/img/map.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Mastermap from '../components/Mastermap.vue'
export default {
  name:'ContactUs',
  components:{
    Mastermap
  },
  data() {
    return {
      masterMap: {
        imgSrc: require('../assets/img/contactUs.jpg'),
        companyName: '联系我们',
        masterTitle: '记忆点源于与众不同，专业感源于整齐划一',
      },
      contactWays:[
        {
          imgSrc:require('../assets/img/contact_iphone.png'),
          title:'商务人员',
          subTitle:'常经理 / 010-68810654'
        },
        {
          imgSrc:require('../assets/img/contact_email.png'),
          title:'公司邮箱',
          subTitle:'hr@cyberstone.com.cn'
        },{
          imgSrc:require('../assets/img/contactLocation.png'),
          title:'公司地址',
          subTitle:'北京市石景山区八大处路49号'
        },{
          imgSrc:require('../assets/img/shifen.jpeg'),
          title:'',
          subTitle:'微信扫描二维码关注我们'
        } 
      ]

    }
  },
}
</script>

<style lang="less" scoped>
  .container {
    display: flex;
    justify-content: center;
    .area  {
      display: flex;
      flex-direction: column;
      margin-top: 60px;
      .top {
        display: flex;
        flex-direction: row;
        background-color: #23233E;
        .item {
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: center;
          width: 300px;
          height: 360px;
          img {
            margin-top: 70px;
            width: 78px;
            height: 78px;
          }
          h2 {
            margin-top: 20px;
            color: #fff;
            font-size: 24px;
          }
          p {
            margin-top: 40px;
            color:#909399 ;
            font-size: 14px;
          }
          .shifen {
            margin-top: 76px;
          }
        }
      }
      .map {
        width: 100%;
      }
    }
  }
</style>